import { Component, Input, OnInit } from '@angular/core'
import * as Highcharts from 'highcharts'
import exporting from 'highcharts/modules/exporting'
import offline from 'highcharts/modules/offline-exporting'

exporting(Highcharts)
offline(Highcharts)

@Component({
    selector: 'app-chart-last-year-overview',
    templateUrl: './chart-last-year-overview.component.html',
    standalone: false
})
export class ChartLastYearOverviewComponent implements OnInit {
  @Input() chartType: 'FAULT' | 'BLOCKED'
  @Input() chartData: { dates: string[]; totals: number[]; x_axis: string[] }
  @Input() chartHeight: number = 220
  @Input() chartBarColor: string = '#ffc000'

  public highChart: typeof Highcharts = Highcharts
  public highChartOptions

  constructor() {}

  public getHighChartOptions(chartData: any): Highcharts.Options {
    const self = this
    return {
      credits: {
        enabled: false,
      },
      chart: {
        height: this.chartHeight,
        width: 420,
        spacingTop: 10,
        spacingLeft: 0,
      },
      exporting: {
        sourceWidth: 1620,
        sourceHeight: 480,
        filename: 'initiators-demand-analysis',
      },
      title: {
        text: this.getChartTitle(),
        style: {
          fontSize: '12px',
          fontFamily: 'Arial, sans-serif',
        },
      },
      legend: {
        enabled: false,
        symbolHeight: 16,
        symbolWidth: 16,
        symbolRadius: 2,
      },
      xAxis: {
        categories: [...chartData.x_axis],
        lineWidth: 0,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Arial, sans-serif',
          },
        },
      },
      yAxis: {
        lineWidth: 0.5,
        title: {
          text: 'Hrs.',
        },
        tickInterval: 2,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Arial, sans-serif',
          },
        },
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            verticalAlign: 'bottom',
            align: 'center',
            formatter(): string {
              return ''
            },
            style: {
              fontSize: '12px',
              fontFamily: 'Arial, sans-serif',
            },
          },
        },
      },
      series: [
        {
          id: 'c1',
          name: 'Process Demands',
          color: this.chartBarColor,
          data: [...chartData.totals],
          type: 'column',
          opacity: 0.95,
          events: {
            click: function(event): void {
              self._clickOnChartBar(event)
            },
          },
        },
      ],
    }
  }

  private getChartTitle(): string {
    if (this.chartType === 'FAULT') {
      return 'Time in Fault – 12 months Overview'
    }
    return 'Time in Blocked – 12 months Overview'
  }

  private _clickOnChartBar(event: any): void {
    const index = event.point.index
    const date = this.chartData.dates[index]
    // if (date) {
    //   const intervalDates = HelperService.fullMonthIntervalFromDate(date)
    //   if (intervalDates) {
    //     const _filter = InitiatorDemandReportFilterModel.fromJson({
    //       tagName: this.tagName,
    //       dtPicker: JSON.stringify({
    //         type: 'D',
    //         dates: intervalDates,
    //       }),
    //     })
    //     if (_filter.tagName === null) {
    //       _filter.tagName = undefined
    //     }
    //     const _calendar = HelperService.getMonthYearFromDate(date)
    //     this.router
    //       .navigate(['/spas/initiators/demand-report'], {
    //         queryParams: { filter: JSON.stringify(_filter), cal: JSON.stringify(_calendar) },
    //       })
    //       .then()
    //   }
    // }
  }

  private _drawHighChart(): void {
    if (this.chartData && this.chartData.totals.length > 0) {
      this.highChartOptions = this.getHighChartOptions(this.chartData)
    } else {
      this.highChartOptions = undefined
    }
  }

  ngOnInit(): void {
    this._drawHighChart()
  }
}
